import raw from "./tokenData";

/** Adapter: packages/design-tokens/tokens.json is the single source of truth. */
export const tokens = raw;

/** Map design-tokens JSON → CSS custom properties (single adapter). */
export function cssVarsFromTokens(): Record<string, string> {
  const c = tokens.color;
  return {
    "--color-canvas": c.canvas.base.value,
    "--color-recess": c.canvas.recess.value,
    "--color-elevated": c.canvas.elevated.value,
    "--color-overlay": c.canvas.overlay.value,
    "--color-ink": c.ink.primary.value,
    "--color-ink-secondary": c.ink.secondary.value,
    "--color-ink-muted": c.ink.muted.value,
    "--color-ink-inverse": c.ink.inverse.value,
    "--color-line": c.line.subtle.value,
    "--color-line-strong": c.line.strong.value,
    "--color-focus": c.line.focus.value,
    "--color-accent": c.brand.accent.value,
    "--color-accent-hover": c.brand.accentHover.value,
    "--color-accent-soft": c.brand.accentSoft.value,
    "--color-accent-decorative": c.brand.accentDecorative.value,
    "--color-mark": c.brand.mark.value,
    "--color-success": c.signal.success.value,
    "--color-success-soft": c.signal.successSoft.value,
    "--color-warning": c.signal.warning.value,
    "--color-warning-soft": c.signal.warningSoft.value,
    "--color-danger": c.signal.danger.value,
    "--color-danger-soft": c.signal.dangerSoft.value,
    "--color-info": c.signal.info.value,
    "--color-info-soft": c.signal.infoSoft.value,
    "--color-offline": c.signal.offline.value,
    "--color-offline-soft": c.signal.offlineSoft.value,
    "--color-demo-bg": c.demo.bannerBg.value,
    "--color-demo-fg": c.demo.bannerFg.value,
    "--color-demo-chip-bg": c.demo.chipBg.value,
    "--color-demo-chip-fg": c.demo.chipFg.value,
    "--font-display": tokens.typography.family.display.value,
    "--font-ui": tokens.typography.family.ui.value,
    "--font-mono": tokens.typography.family.mono.value,
    "--radius-sm": tokens.size.radius.sm.value,
    "--radius-md": tokens.size.radius.md.value,
    "--radius-lg": tokens.size.radius.lg.value,
    "--shadow-raised": tokens.elevation.raised.value,
    "--shadow-soft": tokens.elevation.soft.value,
    "--touch-min": tokens.size.shell.touchMin.value,
    "--nav-height": tokens.size.shell.navHeightMobile.value,
    "--topbar-height": tokens.size.shell.topBarHeight.value,
    "--rail-width": tokens.size.shell.railWidthDesktop.value,
    "--content-max": tokens.size.shell.contentMax.value,
    "--status-rail": tokens.size.shell.statusRailWidth.value,
  };
}

/** Apply token CSS vars on `:root` before paint so body/html inherit fonts and colors. */
export function applyTokenCssVars(target: HTMLElement = document.documentElement): void {
  for (const [name, value] of Object.entries(cssVarsFromTokens())) {
    target.style.setProperty(name, value);
  }
}

export function railColor(lifecycleOrState: string): string {
  const rail = tokens.color.rail as Record<string, { value: string } | undefined>;
  const fallback = tokens.color.signal.offline.value;
  const direct = rail[lifecycleOrState]?.value;
  if (direct) return direct;
  const opMap: Record<string, string> = {
    accepted: rail.operationAccepted?.value ?? fallback,
    running: rail.operationRunning?.value ?? fallback,
    succeeded: rail.operationSucceeded?.value ?? fallback,
    failed: rail.operationFailed?.value ?? fallback,
    reconciling: rail.operationReconciling?.value ?? fallback,
    cancel_requested: rail.operationReconciling?.value ?? fallback,
    canceled: rail.operationFailed?.value ?? fallback,
  };
  return opMap[lifecycleOrState] ?? fallback;
}
